import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import { designSystem } from '@yola/ws-ui';
import getBlockSettingsTabs from '../helpers/get-block-settings-tabs';
import BlockSettingsContext from '../contexts/block-settings-context';

const { Tabs } = designSystem;

const BlockSettingsTabsContainer = () => {
  const blockSettingsContext = useContext(BlockSettingsContext);

  const {
    activeTabId,
    captions,
    options: { optionalChildren, displayOptions },
    blockItems,
    timestamp,
    displayBlockLayout,
    scrollContainerRef,
    originalBlock,
    updateSharedData,
  } = blockSettingsContext;

  const { isBlockLayoutSwitchingDisabled } = originalBlock;

  const blockSettingsTabs = useMemo(
    () =>
      getBlockSettingsTabs({
        captions,
        options: {
          optionalChildren,
          displayOptions,
        },
        blockItems,
        isBlockLayoutSwitchingDisabled,
        timestamp,
        displayBlockLayout,
        updateSharedData,
      }),
    [
      captions,
      optionalChildren,
      displayOptions,
      blockItems,
      isBlockLayoutSwitchingDisabled,
      timestamp,
      displayBlockLayout,
      updateSharedData,
    ]
  );

  const panelClassName = classNames('ws-block-settings-dialog__tab-panels', {
    'ws-block-settings-dialog__tab-panels--mobile': bowser.mobile,
  });

  return (
    <div className={panelClassName}>
      <Tabs
        defaultActiveTabId={activeTabId}
        scrollContainerRef={scrollContainerRef}
        skipRenderInactiveContent
        noSideSpacing
      >
        {blockSettingsTabs}
      </Tabs>
    </div>
  );
};

export default BlockSettingsTabsContainer;
